export const fetchClient = async params => {
  return await window.$vue.$get({ endpoint: "/person/search/", params })
}

export const fetchBepeople = async document => {
  return await window.$vue.$get({ endpoint: `/person/legal/${document}` })
}

export const saveClient = async data => {
  return await window.$vue.$post({ endpoint: "/person", data })
}

export const verifyClient = async uuid => {
  return await window.$vue.$post({ endpoint: `/person/${uuid}/verify` })
}

export const updateClient = async (uuid, data) => {
  return await window.$vue.$put({
    endpoint: `/person/${uuid}`,
    data
  })
}

export const fetchProfessions = async params => {
  return await window.$vue.$get({
    endpoint: "/person/list-professions",
    params
  })
}

export const fetchCompanyTypes = async params => {
  return await window.$vue.$get({
    endpoint: "/person/list-legal-types",
    params
  })
}

export const checkEmail = async params => {
  return await window.$vue.$get({
    endpoint: "/validation/email/verify",
    params
  })
}

export const fetchContactType = async params => {
  return await window.$vue.$get({
    endpoint: "/person/list-contact-types",
    params
  })
}

export const verifyLegalResponsibleDocument = async (params, document) => {
  return await window.$vue.$get({
    endpoint: `/person/legal/${document}/validate-representative-cpf`,
    params
  })
}

export const verifyDuplicatedClientContact = async data => {
  return await window.$vue.$post({
    endpoint: "/person/validate-customer-contacts",
    data
  })
}

export const listCustomerOrigin = async () => {
  return await window.$vue.$get({
    endpoint: "/sale/list-customer-origin"
  })
}
